import { render, staticRenderFns } from "./InventoryInboundLogs.vue?vue&type=template&id=892c61a2&scoped=true"
import script from "./InventoryInboundLogs.vue?vue&type=script&lang=js"
export * from "./InventoryInboundLogs.vue?vue&type=script&lang=js"
import style0 from "./InventoryInboundLogs.vue?vue&type=style&index=0&id=892c61a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c61a2",
  null
  
)

export default component.exports